export const Calendar = () => {
    return (
        <section className='calendar'>
            <div className='container'>
                <h2 className='calendar__title title'>Календарь конкурса</h2>
                <div className='calendar__wrap'>
                    <div className='calendar__card'>
                        <div className='calendar__card-title text-s24'>
                            старт <br /> конкурса
                        </div>
                        <div className='calendar__card-date text-s24'>
                            <span>10</span> <br /> июля
                        </div>
                    </div>
                    <div className='calendar__card'>
                        <div className='calendar__card-title text-s24'>
                            окончание <br />
                            приема заявок
                        </div>
                        <div className='calendar__card-date text-s24'>
                            <span>10</span> <br /> октября <small>(18:00 по мск)</small>
                        </div>
                    </div>
                    <div className='calendar__card'>
                        <div className='calendar__card-title text-s24'>
                            определение <br /> победителей
                        </div>
                        <div className='calendar__card-date text-s24'>
                            <span>8</span> <br /> декабря
                        </div>
                    </div>
                    <div className='calendar__card'>
                        <div className='calendar__card-title text-s24'>
                            награждение <br /> победителей
                        </div>
                        <div className='calendar__card-date text-s24'>
                             <span>17 </span> <br /> января
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
